const baseUrl = () => {
  let url = process.env.REACT_APP_API_URL

  if (window.location.hostname === 'www.offerzen.com') {
    return url
  }

  const cookieValue = document.cookie
    .split('; ')
    .find(v => v.startsWith('ozapi='))
    ?.split('=')[1]
  if (cookieValue) {
    url = `https://zadev-pr-${cookieValue}.ra.offerzen.dev`
  }

  return url
}

export default baseUrl
